<script setup>
import { PhxIcon } from '@phx-styleguides/rdu';
import { onMounted, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  videoId: {
    type: String,
    required: true,
  },
  videoSrc: {
    type: String,
    required: true,
  },
  posterSrc: {
    type: String,
    default: '',
  },
  sourceType: {
    type: String,
    default: 'video/mp4',
  },
  isLoop: {
    type: Boolean,
    default: false,
  },
  autoplay: {
    type: Boolean,
    default: true,
  },
  initBackgroundVideo: {
    type: Boolean,
    default: true,
  },
  additionalClasses: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const mediaWrapper = ref(null);
const media = ref(null);
const isPlaying = ref(true);

const mediaControlLabel = computed(() =>
  isPlaying.value ? t('Accessibility.videoPlay') : t('Accessibility.videoPause'),
);

onMounted(() => {
  if (mediaWrapper.value) {
    if (props.initBackgroundVideo) {
      new Toolkit.SGPHXBackgroundVideo(mediaWrapper.value);
    }

    media.value.addEventListener('play', () => {
      isPlaying.value = true;
    });
    media.value.addEventListener('pause', () => {
      isPlaying.value = false;
    });
  }
});
</script>

<template>
  <div :id="videoId" ref="mediaWrapper" class="sgphx-video-player sgphx-background-video" :class="additionalClasses">
    <video
      ref="media"
      class="sgphx-background-video__video"
      :poster="posterSrc"
      :autoplay="autoplay"
      muted
      playsinline
      :loop="isLoop"
      aria-hidden="true"
    >
      <source :data-src="videoSrc" :type="sourceType" />
    </video>

    <button
      class="sgphx-background-video__controls sgphx-btn sgphx-btn--icon-only sgphx-btn--icon"
      type="button"
      :aria-label="mediaControlLabel"
    >
      <phx-icon icon="play-20" class="sgphx-background-video__icon sgphx-background-video__icon--play" />
      <phx-icon icon="pause-20" class="sgphx-background-video__icon sgphx-background-video__icon--pause" />
    </button>

    <div class="sgphx-loader sgphx-loader--light sgphx-loader--sm sgphx-background-video__loader">
      <div class="sgphx-loader__inner"></div>
    </div>
  </div>
</template>
